export const payrollCostsSelector = ({ activeIds: { forgivenessId }, ...state }) => ({
  requestedForgivenessAmount: state.form?.sba3508SForm?.values?.requestedForgivenessAmount,
  pppLoanAmount: state.entities.loanForgiveness.byId[forgivenessId]?.loanInformation?.pppLoanAmount,
});
